(() => {
  'use strict';
  const storageKey = 'martenbrown-unverbindliche-vorbestellung-v1';
  const validQuantity = value => Number.isInteger(value) && value >= 1 && value <= 999;
  function init() {
    const root = document.querySelector('[data-mb-reservation]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const success = root.querySelector('[data-mb-success]');
    if (success) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      success.focus();
      return;
    }
    const form = root.querySelector('#MBReservationForm');
    const rows = form?.querySelector('[data-mb-rows]');
    const firstRow = rows?.querySelector('[data-mb-row]');
    if (!firstRow) return;
    const t = JSON.parse(root.querySelector('[data-mb-translations]').textContent);
    const rowTemplate = firstRow.cloneNode(true);
    const catalogue = new Map([...firstRow.querySelector('select').options]
      .filter(o => o.dataset.key).map(o => [o.dataset.key, Object.freeze({value: o.value, label: o.textContent.trim()})]));
    const maxRows = catalogue.size;
    const add = form.querySelector('[data-mb-add]');
    const submit = form.querySelector('[data-mb-submit]');
    const submitLabel = submit.textContent;
    const error = form.querySelector('[data-mb-error]');
    const reference = form.querySelector('[data-mb-reference]');
    reference.value = `MB-${globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2,10)}`}`;
    let submitting = false;
    let pendingSubmit = null;
    const readRows = () => [...rows.querySelectorAll('[data-mb-row]')].map(row => {
      const option = row.querySelector('select').selectedOptions[0];
      const known = catalogue.get(option?.dataset.key);
      return {key: known?.value === option?.value ? option.dataset.key : '', qty: Number(row.querySelector('[data-mb-quantity]').value)};
    });
    const save = () => {
      const items = readRows().filter(item => catalogue.has(item.key) && validQuantity(item.qty));
      try { sessionStorage.setItem(storageKey, JSON.stringify({at: Date.now(), items})); } catch (_) {}
    };
    const showError = message => {error.textContent = message; error.hidden = !message;};
    const clearValidity = () => {rows.querySelectorAll('select,input').forEach(input => input.setCustomValidity('')); showError('');};
    const update = () => {
      clearValidity();
      const allRows = [...rows.querySelectorAll('[data-mb-row]')];
      allRows.forEach((row,i) => {
        const n=i+1;
        const select=row.querySelector('select');
        const qty=row.querySelector('[data-mb-quantity]');
        row.querySelector('legend').textContent=t.article.replace('__NUMBER__',n);
        select.id=`MBProduct-${n}`; select.name=`contact[Artikel ${n}]`;
        qty.id=`MBQuantity-${n}`; qty.name=`contact[Menge ${n}]`;
        row.querySelectorAll('label')[0].htmlFor=select.id;
        row.querySelectorAll('label')[1].htmlFor=qty.id;
        row.querySelector('[data-mb-remove]').hidden=allRows.length===1;
      });
      add.hidden=false; add.disabled=allRows.length>=maxRows;
      save();
    };
    const appendItem = (item={}) => {
      if (rows.children.length>=maxRows) return;
      const row=rowTemplate.cloneNode(true);
      row.querySelector('select').value=catalogue.get(item.key)?.value || '';
      row.querySelector('[data-mb-quantity]').value=validQuantity(item.qty)?item.qty:1;
      rows.append(row);
    };
    let saved=[];
    try {
      const data=JSON.parse(sessionStorage.getItem(storageKey)||'null');
      const age=Date.now()-data?.at;
      const seen=new Set();
      if (data && age>=0 && age<7*86400000 && Array.isArray(data.items)) saved=data.items.filter(item=>{
        if (!item || !catalogue.has(item.key) || !validQuantity(item.qty) || seen.has(item.key)) return false;
        seen.add(item.key); return true;
      }).slice(0,maxRows);
    } catch (_) {}
    const params=new URLSearchParams(location.search);
    const incoming=params.get('artikel');
    if(catalogue.has(incoming)) {
      const existing=saved.find(item=>item.key===incoming);
      const qty=params.has('menge')||!existing?Number(params.get('menge')||1):existing.qty;
      saved=[{key:incoming,qty:validQuantity(qty)?qty:1},...saved.filter(item=>item.key!==incoming)];
    }
    if(saved.length) {rows.replaceChildren();saved.slice(0,maxRows).forEach(appendItem);}
    update();
    if(incoming&&!catalogue.has(incoming)) showError(t.unknown_link);
    add.addEventListener('click',()=>{appendItem();update();rows.lastElementChild.querySelector('select').focus();});
    rows.addEventListener('change',update);
    rows.addEventListener('input',event=>{if(event.target.matches('[data-mb-quantity]')){clearValidity();save();}});
    rows.addEventListener('click',event=>{
      const remove=event.target instanceof Element&&event.target.closest('[data-mb-remove]');
      if(!remove||rows.children.length<2)return;
      remove.closest('[data-mb-row]').remove();update();add.focus();
    });
    form.addEventListener('submit',event=>{
      if(submitting||(pendingSubmit&&!pendingSubmit.defaultPrevented)){event.preventDefault();return;}
      clearValidity();
      const items=readRows();const seen=new Set();let message='';
      [...rows.querySelectorAll('[data-mb-row]')].forEach((row,i)=>{
        const item=items[i];const select=row.querySelector('select');const qty=row.querySelector('[data-mb-quantity]');
        if(!catalogue.has(item.key)){select.setCustomValidity(t.invalid_product);message ||= t.invalid_product;}
        else if(seen.has(item.key)){select.setCustomValidity(t.duplicate);message ||= t.duplicate;}
        seen.add(item.key);
        if(!validQuantity(item.qty)){qty.setCustomValidity(t.invalid_quantity);message ||= t.invalid_quantity;}
      });
      if(!items.length||items.length>maxRows)message ||= t.invalid_form;
      if(!form.reportValidity()||message){event.preventDefault();showError(message||t.invalid_form);return;}
      form.querySelector('[data-mb-time]').value=new Date().toISOString();
      const lines=['MARTENBROWN_VORMERKUNG_V1',`Referenz: ${reference.value}`,'Kostenlose, unverbindliche Vormerkung. Keine Zahlung, noch kein Kaufvertrag.',''];
      items.forEach((item,i)=>{
        lines.push(`${i+1}. ${catalogue.get(item.key).label} | ${item.qty} Stück | ID: ${item.key}`);
        lines.push('15 % Rabatt beim späteren Kauf | wieder erhältlich frühestens ab März 2027.');
      });
      lines.push('','Rabatt auf die hier vorgemerkten Artikel beim späteren Kauf.','Genauen Termin, Verfügbarkeit und endgültigen Preis vor dem Kauf bestätigen.');
      form.querySelector('[data-mb-summary]').value=lines.join('\n');
      save();pendingSubmit=event;
      queueMicrotask(()=>{
        if(event.defaultPrevented){if(pendingSubmit===event)pendingSubmit=null;return;}
        submitting=true;submit.disabled=true;submit.setAttribute('aria-busy','true');submit.textContent=t.submitting;
      });
    });
    window.addEventListener('pageshow',()=>{
      submitting=false;pendingSubmit=null;submit.disabled=!catalogue.size;
      submit.removeAttribute('aria-busy');submit.textContent=submitLabel;
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
